var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector105(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 196,
    viewBox: "0 0 293 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2298 0.259766C17.5198 28.7098 12.2598 60.5898 7.74977 95.2198C7.37977 98.0398 6.17977 111.42 5.99977 114.25L0.759766 193.57C17.9198 168.86 21.7598 164.86 40.0398 148.67C44.5198 144.7 53.3198 138.33 64.3098 132.06C67.5998 130.18 70.8698 128.46 74.0998 126.86C97.2398 115.45 123.85 112.14 150.4 112.46C218.13 113.28 276.22 72.4098 289.9 15.9498C291.16 10.7298 292.03 5.48977 292.51 0.259766",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector105);
export default __webpack_public_path__ + "static/media/vector10-5.2a08e9f52be20ffec38bb376b56f3532.svg";
export { ForwardRef as ReactComponent };